import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';

import ApiUiController from '../../../controller/ApiUiController';
import RoleAPI from '../../../api/RoleAPI';
import Perm1 from './PermissionModule';
import Perm2 from './PermissionAUDR';
import Perm3 from './PermissionAUD';
import Perm4 from './ProjectPropertyPermission';
import Perm5 from './LeadPermissionModule';
import Perm6 from './PermissionCallMeeting';
import Perm7 from './PermissionLRP';
import Perm8 from './PermissionLeadSearch';
import Perm9 from './PermissionContact';
import Util from '../../../util/Util';
import Const from '../../../util/Constants';
import RoleConst from '../../../util/RoleConst';
import withRouter from '../../../util/WithRouter';
import { FormControl } from 'react-bootstrap';

class RoleUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.modules = reactLocalStorage.getObject(Const.Model);
    this.id = parseInt(props.match.params.roleId);
    this.role = {id: 0, name: ''};
    this.state = { inApiCall: this.id !== 0, value: '', error: false  , active:"Basic Permission"};
    this.basePath = this.props.match.path
    this.basePath = this.basePath.substring(0, this.basePath.indexOf('/add-edit'));
    this.tabs = ["Basic Permission","Advanced Permission"]
  }
  
  componentDidMount() { if(this.id !== 0) { RoleAPI.get(this.id, this.onReceived, this.onFail); } }
  onFail = () => this.setState({ ...this.state, inApiCall: false });
  onReceived = role => {
    this.role = role; 
    this.setState({ ...this.state, inApiCall: false, value: role.name });
  }
  
  change = (module, permission) => this.role[module] = permission;
  
  handleChange = event => {
    this.role.name = event.target.value;
    const error = this.role.name.trimEnd().length === 0;
    this.setState({ ...this.state, value: this.role.name, error: error});
  }
  onSave = () => {
    if(!this.role.name || !this.role.name.trim()) {
      Util.showNotification('Invalid Field', 'Please fill all mandatory fields', 'danger');
      return;
    }
    this.setState({ ...this.state, inApiCall: true });
    RoleAPI.save(this.role, this.onRoleSaved, this.onFail);
  }
  onRoleSaved = () => {
    Util.showNotification('Successful', 'Role successfully saved', 'success')
    this.props.navigate(this.basePath);
  }

  permission = key => {
    if(key === 'lead') {
      return <Perm5 role={this.role} change={this.change} module={key !== 'call' ? key : RoleConst.Call} />
    } else if(key === 'contact') {
      return <Perm9 role={this.role} change={this.change} module={key !== 'call' ? key : RoleConst.Call} />
    } else if(key === 'customer' || key === 'sales_order'
      || key === 'product') {
      return <Perm1 role={this.role} change={this.change} module={key !== 'call' ? key : RoleConst.Call} />
    } else if(key === 'call' || key === 'meeting' || key === 'attendance') {
    return <Perm6 role={this.role} change={this.change} module={key !== 'call' ? key : RoleConst.Call} />
  } else if(key === 'document' || key === 'email' || key === 'user' || key === 'campaign'
      || key === 'import' || key === 'export' || key === 'sms' || key === 'cold_data') {
      return <Perm2 role={this.role} change={this.change} module={key} />
    } else if(key === 'property' || key === 'project') {
      return <Perm4 role={this.role} change={this.change} module={key} />
    } else if(key === 'report') {
      return <Perm7 role={this.role} change={this.change} module={key} />
    } else if(key === 'lead_search') {
      return <Perm8 role={this.role} change={this.change} module={key} />
    } 
    return <Perm3 role={this.role} change={this.change} module={key !== 'call' ? key : RoleConst.Call} />
  }
  onTabClick = tab => this.setState({...this.state,active:tab})

  render() {
    let basicRoles = ["lead", "contact", "sales_order", "customer", "call","meeting" , "email","quote", "attendance","sms" , "whatsapp" , "note" ];

    let basicUi = basicRoles.map((key, i) =>  
           <tr key={`perm_module_${key}`}>
             <td>{i + 1}</td>
             <td>{key}</td>
             <td>{this.modules[key] ? this.modules[key].model_name : key}</td>
             <td>{this.permission(key)}</td>
         </tr>       
   );

    let advancedUi = Object.keys(this.modules).filter((key)=>!basicRoles.includes(key)).map((key, i) => 
            <tr key={`perm_module_${key}`}>
              <td>{i + 1}</td>
              <td>{key}</td>
              <td>{this.modules[key]? this.modules[key].model_name : key}</td>
              <td>{this.permission(key)}</td>
          </tr>       
    );
    
    if(this.modules.length === 0) {
      basicUi = <tr><td colSpan="3">No records Found</td></tr>;
      advancedUi = <tr><td colSpan="3">No records Found</td></tr>;
    }

    return (
      <div className="sectionform pt-4">
        <ApiUiController inApiCall={this.state.inApiCall}>
          <div className="container form-cont">  
            <div className="row">
              <div className="col-md-8"><h2>Role</h2></div>
              <div className="col-md-4 text-right">
                <Button variant="success" onClick={this.onSave}>Save</Button>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <FormControl type="text" placeholder='E.g. Telecaller, Sales executive' value={this.state.value}
                    className={this.state.error ? "mr-sm-2 error-w" : "mr-sm-2" }
                    onChange={this.handleChange}/>
                </div>
              </div>
              
              <div className="col-md-12 ">
                      <div className="content-box">
                        <nav className="project-tab">
                        <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                            { this.tabs ? this.tabs.map((tab, i) => 
                                <span id="nav-home-tab"  data-toggle="tab" role="tab" aria-controls="nav-home"
                                  className={`alert alert-dark nav-item nav-link ${this.state.active === tab ? 'active' : ''}`} 
                                  aria-selected="true" key={`tab_${i}`} onClick={() => this.onTabClick(tab)}>
                                  {tab}
                                </span>
                              ): null
                            }
                          </div>
                        </nav>
                      </div>
                    </div>
              <div className="col-md-12">
                <Table  bordered>
                <tbody>
                  {this.state.active === "Basic Permission" ? basicUi : advancedUi}
                </tbody>
                </Table>
             </div>
            </div>
          </div>
        </ApiUiController>
      </div>
    );
  }
}

export default withRouter(RoleUpdate);
